const initState =
{
  portfolio         : null,
  portfolioArray    : [],
  counter           : 0,

  business          : null,

  construction      : null,
  design            : null,
  images            : null,
}

const portfolioReducer = (state = initState, action) =>
{
  switch (action.type)
  {
    case 'SET_PORTFOLIO':
      return {
        ...state,
        portfolio: action.portfolio
      };

    case 'SET_PORTFOLIO_ARRAY':
      return {
        ...state,
        portfolioArray: action.portfolioArray
      };

    case 'SET_PORTFOLIO_COUNTER':
      return {
        ...state,
        counter: action.counter
      };

    case 'SET_PORTFOLIO_BIZ':
      return {
        ...state,
        business: action.business
      };

    case 'SET_PORTFOLIO_CONSTRUCTION':
      return {
        ...state,
        construction: action.construction
      };

    case 'SET_PORTFOLIO_DESIGN':
      return {
        ...state,
        design: action.design
      };

    case 'SET_PORTFOLIO_IMAGES':
      return {
        ...state,
        images: action.images
      };

    default:
      return state; 
  }
}

export default portfolioReducer;